import getConfig from 'next/config'
import axios from 'axios';

const { publicRuntimeConfig } = getConfig();

// SSR roda dentro do cluster: o host público (api.*.hml / api.staging) passa pelo
// ingress-nginx com PROXY protocol (LBaaS MGC) e o tráfego Pod→ExternalIP morre com
// ECONNRESET — mesmo motivo do dual-URL em src/services/api.ts. Em SSR usamos a URL
// interna do cluster (INTERNAL_API_V2, server-only); no browser mantemos o host
// público (publicRuntimeConfig). Sem INTERNAL_API_V2 definida (ex: produção), o
// fallback mantém o host público — comportamento inalterado.
const isServer = typeof window === 'undefined';
const apiV2BaseSSR = process.env.INTERNAL_API_V2 || publicRuntimeConfig.NEXT_PUBLIC_API_V2;

const api = axios.create({
  baseURL: isServer ? apiV2BaseSSR : publicRuntimeConfig.NEXT_PUBLIC_API_V2,
  timeout: 10000,
  responseType: 'json',
});

export { api };
